const encounterRewards = new Map<string, string>([
  ['Ally', 'finding allies'],
  ['Blessing', 'receiving a blessing'],
  ['Clue', 'finding clues'],
  ['Common Item', 'finding common items'],
  ['Money', 'finding money'],
  ['Sanity', 'recovering Sanity'],
  ['Skill', 'finding skills'],
  ['Spell', 'finding spells'],
  ['Stamina', 'recovering Stamina'],
  ['Unique Item', 'finding unique items'],
]);

export function locationEncounterPresentation(encounter?: string) {
  const reward = encounter && encounterRewards.get(encounter);
  return reward ? {
    icon: `/icons/${encodeURIComponent(encounter!)}.svg`,
    description: `Increased chance of ${reward} in Arkham Encounters here.`,
  } : undefined;
}
